export default "__VITE_ASSET__C$dLC5Ts__"